import script from "./FiltrosParcerias.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosParcerias.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosParcerias.vue?vue&type=style&index=0&id=b0066e7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0066e7e"]])

export default __exports__